import {loadEditableAssetRegistry,notifyLiveChanged,saveAssetRegistry} from './assetRepository';
import {MASTER_PALETTE} from './assets';
import type {AssetRegistry,AssetVersion,RWAsset} from './assets';
import {portableAudioStorage} from './audioStorage';

declare global {
  interface Window {
    RWUnifiedAssets?:{
      loadRegistry:()=>Promise<AssetRegistry|null>;
      saveRegistry:(registry:AssetRegistry)=>Promise<boolean>;
      notifyLiveChanged:(asset:RWAsset,version:AssetVersion)=>Promise<void>;
      putAudioBlob:(id:string,blob:Blob)=>Promise<string|void>;
      getAudioBlob:(id:string)=>Promise<Blob|undefined>;
      deleteAudioBlob:(id:string)=>Promise<void>;
      hasAudioBlob:(id:string)=>Promise<boolean>;
      palette:typeof MASTER_PALETTE;
    };
  }
}
export function installUnifiedBridge(){
  window.RWUnifiedAssets={
    loadRegistry:loadEditableAssetRegistry,
    saveRegistry:async registry=>{await saveAssetRegistry(registry);return true},
    notifyLiveChanged:async(asset,version)=>{await notifyLiveChanged(asset,version)},
    putAudioBlob:portableAudioStorage.putAudioBlob,
    getAudioBlob:portableAudioStorage.getAudioBlob,
    deleteAudioBlob:portableAudioStorage.deleteAudioBlob,
    hasAudioBlob:portableAudioStorage.hasAudioBlob,
    palette:MASTER_PALETTE
  };
}
